/**
 * Local viewed-Sparks tracker.
 *
 * Sparks have a 24-hour TTL on the backend, so we don't need to prune entries
 * aggressively — the set can comfortably hold a few hundred IDs. We cap at
 * 1000 entries (FIFO) to keep localStorage small.
 *
 * This client-side memory is what powers the "vanish-after-viewing" behaviour
 * of the SparksTray (similar to Snapchat). The backend `viewers` array is
 * still maintained for cross-device sync and analytics, but this set gives us
 * an instant, reliable signal even for anonymous viewers and even before the
 * server roundtrip completes.
 */
const KEY = 'fx_seen_sparks_v1';
const MAX = 1000;

function read() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

function write(arr) {
  try {
    const trimmed = arr.length > MAX ? arr.slice(arr.length - MAX) : arr;
    localStorage.setItem(KEY, JSON.stringify(trimmed));
  } catch {
    // localStorage full / disabled — non-fatal
  }
}

export function markSparkViewed(sparkId) {
  if (!sparkId) return;
  const arr = read();
  if (arr.includes(sparkId)) return;
  arr.push(sparkId);
  write(arr);
}

export function getViewedSet() {
  return new Set(read());
}

export function isAuthorFullyViewed(author, viewedSet) {
  if (!author || !Array.isArray(author.sparks) || author.sparks.length === 0) {
    return false;
  }
  return author.sparks.every(s => viewedSet.has(s.spark_id));
}
